import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './met-activity-sector.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MetActivitySectorDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const metActivitySectorEntity = useAppSelector(state => state.metActivitySector.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="metActivitySectorDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.metActivitySector.detail.title">MetActivitySector</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{metActivitySectorEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.metActivitySector.code">Code</Translate>
            </span>
          </dt>
          <dd>{metActivitySectorEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.metActivitySector.name">Name</Translate>
            </span>
          </dt>
          <dd>{metActivitySectorEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.metActivitySector.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{metActivitySectorEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.metActivitySector.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{metActivitySectorEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.metActivitySector.status">Status</Translate>
            </span>
          </dt>
          <dd>{metActivitySectorEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/met-activity-sector" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/met-activity-sector/${metActivitySectorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MetActivitySectorDetail;
